import styled from '../../../theme/styled-with-theme';
import { mediaQueries } from '../../../styles/media-queries';

import { GlImage } from '../../Image';
import { Flexbox } from '../../Flexbox';
import { Column } from '../../Layout';

export const ImageWrapper = styled('div')`
  position: relative;
  width: 100%;
`;

export const HeroImage = styled(GlImage)`
  flex: 1 1 auto;
  border-radius: ${({ theme }) => theme.borderRadius.block};

  ${mediaQueries.desktop} {
    border-radius: ${({ theme }) => theme.borderRadius.block_desktop};
  }
`;

export const Tag = styled('div')`
  background-color: ${({ theme }) => theme.color.tagBg};
  color: ${({ theme }) => theme.color.tagText};
  border-radius: ${({ theme }) => theme.borderRadius.tag_0};
  font-size: ${({ theme }) => theme.fontSize.tag_0};
  padding: ${({ theme }) => theme.spacing.s};
  line-height: 1;
  flex: 0 0 auto;
  margin: ${({ theme }) => theme.spacing['2xs']};

  ${mediaQueries.tablet} {
    font-size: ${({ theme }) => theme.fontSize.tag_tablet};
  }

  ${mediaQueries.desktop} {
    font-size: ${({ theme }) => theme.fontSize.tag_desktop};
  }
`;

export const BlogTextContainer = styled(Flexbox)`
  width: 100%;
`;

export const DisclaimerColumn = styled(Column)`
  order: 2;
  ${mediaQueries.tablet} {
    order: 4;
  }
`;
